export const esES:ILan = {
    invMsg1: 'Fecha de emisión:',
    invMsg2: 'Fecha de vencimiento:',
    invMsg3: 'FACTURA',
    invMsg4: 'Número de factura',
    invMsg5: 'NIF',
    invMsg6: 'Concepto',
    invMsg7: 'Base UD.',
    invMsg8: 'Subtotal:',
    invMsg9: 'IVA',
    invMsg10: 'IRPF',
    invMsg11: 'TOTAL:',
    invCurrency: '€'
}

export interface ILan {
    invMsg1?: string,
    invMsg2?: string,
    invMsg3?: string,
    invMsg4?: string,
    invMsg5?: string,
    invMsg6?: string,
    invMsg7?: string,
    invMsg8?: string,
    invMsg9?: string,
    invMsg10?: string,
    invMsg11?: string,
    invCurrency?: string,
}

export const enEN:ILan = {
    invMsg1: 'Date:',
    invMsg2: 'Due:',
    invMsg3: 'INVOICE',
    invMsg4: 'Invoice number:',
    invMsg5: 'VAT',
    invMsg6: 'Concept',
    invMsg7: 'Price',
    invMsg8: 'Subtotal:',
    invMsg9: 'VAT',
    invMsg10: 'IRPF',
    invMsg11: 'TOTAL:',
    invCurrency: '£'
}